// import { get } from 'svelte/store';
// import { sessionId } from '../stores/sessionStore.js';

export async function fetchWithCredentials(url, options = {}) {
  // Extract sessionid and csrftoken from cookies
  // const sessionid = document.cookie.replace(/(?:(?:^|.*;\s*)sessionid\s*\=\s*([^;]*).*$)|^.*$/, "$1");
  const csrftoken = document.cookie.replace(/(?:(?:^|.*;\s*)csrftoken\s*\=\s*([^;]*).*$)|^.*$/, '$1');

  // Add sessionid and csrftoken to headers
  options.headers = options.headers || {};
  options.headers['Content-Type'] = 'application/json';
  options.headers['X-CSRFToken'] = csrftoken;

  // Make the fetch request
  let response;
  response = await fetch(url, { ...options, credentials: 'include' });
  return response;
}
